import dayjs from 'dayjs';

export const padLeft = (number, pad) => {
  let r = number ? number.toString() : '';
  while (r.length < pad) r = `0${r}`;
  return r;
};

export const ddmmyyyToString = (dd, mm, yyyy) => `${yyyy}-${padLeft(mm, 2)}-${padLeft(dd, 2)}`;

export const ddmmyyyDecode = (dateStr = '') => {
  const dd = dateStr ? dateStr.substr(8, 2) : '';
  const mm = dateStr ? dateStr.substr(5, 2) : '';
  const yyyy = dateStr ? dateStr.substr(0, 4) : '';
  return { dd, mm, yyyy };
};

export const dateFormat = (dateStr) => {
  const { dd, mm, yyyy } = ddmmyyyDecode(dateStr);
  if (dd && mm && yyyy) return ddmmyyyToString(dd, mm, yyyy);
  return '';
};

export const nYearsAgo = (n) => {
  const date = dayjs().subtract(n, 'year');
  return date.format('YYYY-MM-DD');
};

export const oneYearAgo = () => nYearsAgo(1);
export const threeYearsAgo = () => nYearsAgo(3);
export const fiveYearsAgo = () => nYearsAgo(5);

export const ytdStartDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  return `${year}-01-01`;
};

export const today = () => {
  return dayjs().format('YYYY-MM-DD');
};

export function getStartAndEndDateByTag(tag) {
  let startDate;
  const endDate = today();

  if (tag.endsWith('y')) {
    const n = Number(tag.replace('y', ''));
    startDate = nYearsAgo(n);
  } else if (tag === 'all') {
    startDate = undefined;
  } else {
    startDate = ytdStartDate();
  }

  return { startDate, endDate };
}
